import { jsx as _jsx } from "react/jsx-runtime";
export function TextInput(props) {
    return (_jsx("input", { spellCheck: false, autoCorrect: "off", autoCapitalize: "off", ...props }));
}
